export const VENDOR_SUPPORT_EMAIL = 'weddingvendors@zola.com';
